export default {"src":"/_next/static/media/features-chat-community.6c712e1f.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};